<ng-container *transloco="let t; prefix: 'orders.customerConfiguration'">
  @if (customer(); as company) {
    <mat-card class="customer-summary" appearance="outlined">
      <mat-card-content class="customer-summary-content">
        <span class="customer-summary-name headline-small-emphasized">{{ company.ragioneSociale }}</span>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('taxCode') }}</span>
          <span class="body-large">{{ company.codiceFiscale || '—' }}</span>
        </div>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('vatNumber') }}</span>
          <span class="body-large">{{ company.partitaIva || '—' }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="contacts-heading">
      <span class="title-medium-emphasized">{{ t('contactsTitle') }}</span>
      <a matButton [routerLink]="['/new-order-proposal/configure-customer/zones']" [queryParams]="{ id: proposalId }">{{ t('backToZones') }}</a>
    </div>

    <form class="contacts-form" [formGroup]="form" (ngSubmit)="continue()">
      <div class="contact-fields">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('contactName') }}</mat-label>
          <input matInput formControlName="nominativo" required>
          <i matSuffix class="fa-regular fa-user" aria-hidden="true"></i>
          <mat-error>{{ t('requiredField') }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('contactRole') }}</mat-label>
          <input matInput formControlName="ruolo">
          <i matSuffix class="fa-regular fa-briefcase" aria-hidden="true"></i>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('contactPhone') }}</mat-label>
          <input matInput type="tel" formControlName="telefono">
          <i matSuffix class="fa-regular fa-phone" aria-hidden="true"></i>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('contactEmail') }}</mat-label>
          <input matInput type="email" formControlName="email" required>
          <i matSuffix class="fa-regular fa-envelope" aria-hidden="true"></i>
          <mat-error>{{ form.controls.email.hasError('required') ? t('requiredField') : t('invalidEmail') }}</mat-error>
        </mat-form-field>
        <mat-form-field class="contact-notes text-area-custom" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('contactNotes') }}</mat-label>
          <textarea matInput formControlName="note" rows="4"></textarea>
        </mat-form-field>
      </div>
      <div class="contacts-actions">
        <button matButton="filled" type="submit" [disabled]="form.invalid || !configuration.destinationForConfiguration()">{{ t('continue') }}</button>
      </div>
    </form>
  } @else {
    <div class="contacts-state">
      <span class="body-large">{{ t('missingCustomer') }}</span>
      <a matButton="outlined" [routerLink]="['/new-order-proposal/new-customer']" [queryParams]="{ id: proposalId }">{{ t('backToSearch') }}</a>
    </div>
  }
</ng-container>
